[
  {
    "id": "pierwsza-krew",
    "name": "Pierwsza krew",
    "description": "Pokonaj pierwszego wroga.",
    "condition": {
      "type": "kills",
      "count": 1
    },
    "reward": {
      "currency": 50
    }
  },
  {
    "id": "pierwsza-wyprawa",
    "name": "Za palisadę",
    "description": "Wróć z pierwszej wyprawy.",
    "condition": {
      "type": "runs",
      "count": 1
    },
    "reward": {
      "currency": 100
    }
  },
  {
    "id": "weteran-wypraw",
    "name": "Weteran wypraw",
    "description": "Ukończ 25 wypraw.",
    "condition": {
      "type": "runs",
      "count": 25
    },
    "reward": {
      "currency": 400,
      "title": "Wędrowiec Pustkowi"
    }
  },
  {
    "id": "setka-wypraw",
    "name": "Sto powrotów",
    "description": "Ukończ 100 wypraw.",
    "condition": {
      "type": "runs",
      "count": 100
    },
    "reward": {
      "currency": 1200,
      "frame": {
        "name": "Ramka Wędrowca",
        "color": "#8fb36a"
      }
    }
  },
  {
    "id": "kosiarz",
    "name": "Kosiarz",
    "description": "Pokonaj łącznie 100 wrogów.",
    "condition": {
      "type": "kills",
      "count": 100
    },
    "reward": {
      "currency": 100
    }
  },
  {
    "id": "postrach-kosci",
    "name": "Postrach kości",
    "description": "Pokonaj łącznie 1000 wrogów.",
    "condition": {
      "type": "kills",
      "count": 1000
    },
    "reward": {
      "currency": 300,
      "title": "Postrach Kości"
    }
  },
  {
    "id": "plaga-nieumarlych",
    "name": "Plaga nieumarłych",
    "description": "Pokonaj łącznie 10 000 wrogów.",
    "condition": {
      "type": "kills",
      "count": 10000
    },
    "reward": {
      "currency": 1000,
      "frame": {
        "name": "Ramka Kosiarza",
        "color": "#c0392b"
      }
    }
  },
  {
    "id": "korona-z-kosci",
    "name": "Korona z kości",
    "description": "Pokonaj Króla Kości.",
    "condition": {
      "type": "boss",
      "enemy": "krol-kosci"
    },
    "reward": {
      "currency": 200,
      "gold": 150
    }
  },
  {
    "id": "koniec-rytualu",
    "name": "Koniec rytuału",
    "description": "Pokonaj Pradawnego Nekromantę.",
    "condition": {
      "type": "boss",
      "enemy": "pradawny-nekromanta"
    },
    "reward": {
      "currency": 300,
      "gold": 250,
      "title": "Łamacz Rytuałów"
    }
  },
  {
    "id": "odwilz",
    "name": "Odwilż",
    "description": "Pokonaj Lodowego Władcę.",
    "condition": {
      "type": "boss",
      "enemy": "lodowy-wladca"
    },
    "reward": {
      "currency": 500,
      "gold": 400,
      "title": "Pogromca Mrozu"
    }
  },
  {
    "id": "lowca-krolow",
    "name": "Łowca królów",
    "description": "Pokonaj Króla Kości 10 razy.",
    "condition": {
      "type": "boss",
      "enemy": "krol-kosci",
      "count": 10
    },
    "reward": {
      "currency": 500,
      "title": "Pogromca Króla Kości"
    }
  },
  {
    "id": "piec-minut-grozy",
    "name": "Pięć minut grozy",
    "description": "Przetrwaj 5 minut na dowolnej wyprawie.",
    "condition": {
      "type": "survive",
      "seconds": 300
    },
    "reward": {
      "currency": 150
    }
  },
  {
    "id": "straznik-grobow",
    "name": "Strażnik grobów",
    "description": "Przetrwaj 10 minut na Przeklętym Cmentarzu.",
    "condition": {
      "type": "survive",
      "zone": "cmentarz",
      "seconds": 600
    },
    "reward": {
      "currency": 250
    }
  },
  {
    "id": "lesny-duch",
    "name": "Leśny duch",
    "description": "Przetrwaj 8 minut w Jesiennym Lesie.",
    "condition": {
      "type": "survive",
      "zone": "las",
      "seconds": 480
    },
    "reward": {
      "currency": 350
    }
  },
  {
    "id": "zahartowany-mrozem",
    "name": "Zahartowany mrozem",
    "description": "Przetrwaj 5 minut w Zamarzniętych Ruinach.",
    "condition": {
      "type": "survive",
      "zone": "ruiny",
      "seconds": 300
    },
    "reward": {
      "currency": 500
    }
  },
  {
    "id": "spokoj-zmarlych",
    "name": "Spokój zmarłych",
    "description": "Pokonaj bossa końcowego Przeklętego Cmentarza.",
    "condition": {
      "type": "clear",
      "zone": "cmentarz"
    },
    "reward": {
      "currency": 300,
      "title": "Oczyściciel Cmentarza"
    }
  },
  {
    "id": "cisza-w-lesie",
    "name": "Cisza w lesie",
    "description": "Pokonaj bossa końcowego Jesiennego Lasu.",
    "condition": {
      "type": "clear",
      "zone": "las"
    },
    "reward": {
      "currency": 500
    }
  },
  {
    "id": "wiosna-w-ruinach",
    "name": "Wiosna w ruinach",
    "description": "Pokonaj bossa końcowego Zamarzniętych Ruin.",
    "condition": {
      "type": "clear",
      "zone": "ruiny"
    },
    "reward": {
      "currency": 800,
      "frame": {
        "name": "Ramka Szronu",
        "color": "#7fd6ff"
      }
    }
  },
  {
    "id": "czterech-straznikow",
    "name": "Czterech strażników",
    "description": "Oczyść Przeklęty Cmentarz każdą klasą.",
    "condition": {
      "type": "clear",
      "zone": "cmentarz",
      "allClasses": true
    },
    "reward": {
      "currency": 1000,
      "title": "Mistrz Czterech Dróg"
    }
  },
  {
    "id": "legenda-pustkowi",
    "name": "Legenda Pustkowi",
    "description": "Oczyść Zamarznięte Ruiny każdą klasą.",
    "condition": {
      "type": "clear",
      "zone": "ruiny",
      "allClasses": true
    },
    "reward": {
      "currency": 3000,
      "title": "Legenda Pustkowi",
      "frame": {
        "name": "Ramka Legendy",
        "color": "#ff9a1f"
      }
    }
  },
  {
    "id": "rozkwit",
    "name": "Rozkwit",
    "description": "Osiągnij 15. poziom na jednej wyprawie.",
    "condition": {
      "type": "level",
      "level": 15
    },
    "reward": {
      "currency": 200
    }
  },
  {
    "id": "niepowstrzymany",
    "name": "Niepowstrzymany",
    "description": "Osiągnij 30. poziom na jednej wyprawie.",
    "condition": {
      "type": "level",
      "level": 30
    },
    "reward": {
      "currency": 600,
      "title": "Niepowstrzymany"
    }
  },
  {
    "id": "pelna-kieszen",
    "name": "Kieszeń pełna błyskotek",
    "description": "Podnieś łącznie 10 przedmiotów wyprawy.",
    "condition": {
      "type": "relics",
      "count": 10
    },
    "reward": {
      "currency": 150
    }
  },
  {
    "id": "kolekcjoner",
    "name": "Kolekcjoner talizmanów",
    "description": "Podnieś łącznie 100 przedmiotów wyprawy.",
    "condition": {
      "type": "relics",
      "count": 100
    },
    "reward": {
      "currency": 600,
      "title": "Kolekcjoner"
    }
  },
  {
    "id": "pierwszy-krag",
    "name": "Pierwszy krąg",
    "description": "Przywołaj 10 razy.",
    "condition": {
      "type": "pulls",
      "count": 10
    },
    "reward": {
      "currency": 100
    }
  },
  {
    "id": "mistrz-kregu",
    "name": "Mistrz kręgu",
    "description": "Przywołaj 100 razy.",
    "condition": {
      "type": "pulls",
      "count": 100
    },
    "reward": {
      "currency": 500,
      "frame": {
        "name": "Ramka Kręgu",
        "color": "#b45cff"
      }
    }
  },
  {
    "id": "fioletowy-blask",
    "name": "Fioletowy blask",
    "description": "Zdobądź epicki przedmiot.",
    "condition": {
      "type": "rarity",
      "rarity": "epicki"
    },
    "reward": {
      "currency": 150
    }
  },
  {
    "id": "zloty-blask",
    "name": "Złoty blask",
    "description": "Zdobądź legendarny przedmiot.",
    "condition": {
      "type": "rarity",
      "rarity": "legendarny"
    },
    "reward": {
      "currency": 500,
      "title": "Wybraniec Losu"
    }
  },
  {
    "id": "do-granic",
    "name": "Do granic",
    "description": "Wzmocnij przedmiot do maksymalnego poziomu.",
    "condition": {
      "type": "maxLevelItem"
    },
    "reward": {
      "gold": 500,
      "title": "Kowal Pustkowi"
    }
  },
  {
    "id": "uczen-obozu",
    "name": "Uczeń obozu",
    "description": "Wykup 10 rang talentów.",
    "condition": {
      "type": "talents",
      "count": 10
    },
    "reward": {
      "gold": 200
    }
  },
  {
    "id": "mistrz-drzewa",
    "name": "Mistrz drzewa",
    "description": "Wykup 40 rang talentów.",
    "condition": {
      "type": "talents",
      "count": 40
    },
    "reward": {
      "currency": 800,
      "title": "Mistrz Drzewa"
    }
  },
  {
    "id": "pelna-sakwa",
    "name": "Pełna sakwa",
    "description": "Zbierz łącznie 5000 złota na wyprawach.",
    "condition": {
      "type": "gold",
      "count": 5000
    },
    "reward": {
      "currency": 300
    }
  }
]